import $ from 'jquery';

const layout = (src)=>`
  <div class="modal modal-preview" data-target='modal-preview'>
    <div class="modal__zoom">
      <div class="modal-content">
        <img src="${src}" alt="" class="js-preview-image">
      </div>
    </div>
  </div>`

const modalPreview = {
  call: function createModal(src){
    $('body').append(layout(src));
    $('.modal-preview').fadeIn(300);
    $('html').addClass('overflow');
  }
}

export default modalPreview;